import rulesets from "../../../lib/rulesets";

const entity = e => {
  let entity = { _id: e._id };
  entity.ruleset = e.ruleset;
  entity.name = e.name || "Commoner";
  entity.player = e._user ? e._user.name : "Souless";
  entity.description = e.description;
  entity.image = e.image;
  entity.personality = e.personality;
  entity.dead = e.dead;

  if (e.core) {
    entity.race = e.core.race;
    entity.ancestry = e.core.ancestry;
    entity.class = e.core.class;
    entity.experience = e.core.experience || 0;
    entity.baseAttackBonus = e.core.baseAttackBonus;
    entity.attributes = e.attributes;
    entity.hitPoints = e.defense.hitPoints;
    entity.deathSaves = e.defense.deathSaves;
    entity.dying = e.defense.dying;

    if (entity.ruleset && entity.hitPoints) {
      entity.hitPoints.total = rulesets[entity.ruleset].getTotalHitPoints(
        entity.hitPoints
      );
    }
    entity.descriptor = rulesets[entity.ruleset].getDescriptor(entity);
  }
  return entity;
};

export const getEntity = state => {
  return entity(state.current);
};

export const getEntities = state => {
  let all = [];
  state.all.forEach(x => {
    all.push(entity(x));
  });
  return all;
};
